import Dynamicore, { SERVICES } from 'services/dynamicore';
import {
  AWS_BUCKET as BUCKET,
  AWS_REGION as REGION,
} from 'settings/aws';

const MAX_ATTEMPTS = 5;

export async function checkKeyExist(path, repository = BUCKET) {
  path = path.replace(`https://${repository}.s3.${REGION}.amazonaws.com/`, '');
  const [company, ...key] = path.replace('company/', '').split('/');

  const checkFile = await Dynamicore(SERVICES.USERS_CHECK_DOCUMENT).post({
    bucket: repository,
    company,
    key: `/${key.join('/')}`,
  });

  return checkFile;
}

/**
* Download file from AWS S3
*
* @param {string} path
*/
export async function download(path, sign = true) {
  try {

    const url = sign
      ? await getSignedUrl(path)
      : path;

    window.open(url);
  } catch (error) {
    return false;
  }

  return true;
}

/**
 * Get signed URL
 *
 * @param {string} path
 */
export async function getSignedUrl(path, expires = 10, repository = BUCKET) {
  let attempts = 0;
  let success = false;
  let url;

  while (attempts < MAX_ATTEMPTS && !success) {
    try {
      path = (path ?? '').replace(`https://${repository}.s3.${REGION}.amazonaws.com/`, '');
      const [company, ...key] = path.replace('company/', '').split('/');

      url = await Dynamicore(SERVICES.USERS_SIGNIN_DOCUMENT).post({
        bucket: repository,
        company,
        expires,
        key: `/${key.join('/')}`,
      });

      success = true;
    } catch (error) {
      attempts++;
      console.error(`Intento ${attempts} fallido:`, error);
      if (attempts >= MAX_ATTEMPTS) {
        throw error;
      }
    }
  }

  return url;
}

/**
* Upload file to AWS S3
*
* @param {string} path
* @param {(Buffer|Uint8Array|Blob|string|Readable)} file
* @param {object} metadata
*/
export async function upload(path, file, metadata = {}, company) {
  if (path.startsWith('company/')) {
    [, company] = path.split('/');
    path = path.replace(`company/${company}`, '');
  }
  let presigned;
  let lastError;

  for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
    try {
      presigned = await Dynamicore(SERVICES.USERS_PRESIGNIN_DOCUMENT).post({
        bucket: BUCKET,
        company,
        expires: 60 * 10,
        key: path,
      });
      break;
    } catch (err) {
      lastError = err;
      if (attempt < MAX_ATTEMPTS) {
        await delay(attempt * 1000);
      }
    }
  }

  if (!presigned) throw lastError;

  const formData = new FormData();
  Object.entries(presigned.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });
  formData.append('file', file instanceof Blob ? file : new Blob([file]));

  for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
    try {
      const response = await fetch(presigned.url, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) throw new Error(`Fetch failed with status ${response.status}`);
      return {
        Location: `https://${BUCKET}.s3.${REGION}.amazonaws.com/${presigned.fields.key}`,
      };
    } catch (err) {
      lastError = err;
      if (attempt < MAX_ATTEMPTS) {
        await delay(attempt * 1000);
      }
    }
  }

  throw lastError;
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
